import react, { useEffect, useState } from "react";
import { AnimationOnScroll } from 'react-animation-on-scroll';
import { Navigate, useNavigate } from 'react-router-dom'
import "animate.css/animate.min.css";
import Typewriter from "typewriter-effect";
import axios from "axios";
import {Helmet} from "react-helmet";
import Darkfoot from "../darkfootbar";
const Blog = ()=>{

  const navigate = useNavigate();
  const [tab, settab] = useState('loading')
  const [planes, setplanes] = useState([])
  const [error, seterror] = useState('')
useEffect(()=>{
  axios.get('https://api.skyex.me/blog').then((Response)=>{
    settab('app')
    if(Response.data.status == 501){
      // console.log(Response.data)
      seterror('Something Wrong happened refresh please the page')
    }else{
      setplanes(Response.data)
    }
  }).catch((error)=>{
    // console.log(error)
    settab('app')
    setplanes([])
    seterror("We can't access our api please check your firewall or contact your network administrator")
  })
},[])
  if(tab == 'app'){
    return (
        <>
          <Helmet>
  <title>Skyex | Blog</title>
  <meta
      name="description"
    
      content="Get your blog started with our powerful, safe blogging platform. Let Skyex handle the back-end so you can focus on what matters most—growing your blog.."
    />
    <meta name="twitter:card" content="summary" />
<meta name="twitter:site" content="@skyex.me" />
<meta name="twitter:title" content="skyex web hosting" />
<meta name="twitter:image" content="data:image/png;base64,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" />

<meta name="twitter:description" content="Get your blog started with our powerful, safe blogging platform. Let Skyex handle the back-end so you can focus on what matters most—growing your blog." />

</Helmet>
        <div className="w-screen h-[6rem] -mt-[6.53rem]  scrollbar-hide bg-[#11131d] text-white">

        </div>
        <div className="w-screen scrollbar-hide pb-96 bg-[#11131d] text-white ">
          <center className='md:hidden'>
          <div className=' p-8  max-w-lg sm:justify-center sm:grid md:flex'>
              <div  className='sm:text-center text-5xl md:text-left p-5 leading-normal'>
              Share your thoughts with anyone, anywhere.

              </div>

              <div className=' mt-4 w-screen p-8'>
                <img alt='servers image' src='https://dc47ezw0257n1.cloudfront.net/uploads/billboard/dedicated-servers.svg?1614683658' className=""/>
              </div>
              {/* <p className='text-gray-200 mt-2 ml-3'>
                Take Your business to a new level with our servers
              </p> */}
              <div className='flex-1 text-left  mt-4 leading-normal   text-xl '>
                <center className='w-auto'>
                <div className='w-[14rem] mt-2 text-left'>
                <i className="fa-solid fa-circle-check mr-1"></i>  Custom themes
                </div>
                <div className='w-[14rem] mt-2 text-left'>
                <i className="fa-solid fa-circle-check mr-1"></i>  Google Ads
                </div>
                <div className='mt-2 w-[14rem] text-left'>
                <i className="fa-solid fa-circle-check mr-1"></i>   Multi-Language
                </div>
                <div className='mt-2 w-[14rem] text-left'>
                <i className="fa-solid fa-circle-check mr-1"></i>   Tech Support
                </div>
                </center>
                <div className='h-12 text-center mt-12 text-5xl'>
                <AnimationOnScroll animateOnce='true' offset='8' animateIn="animate__bounceIn">
                plans
                  </AnimationOnScroll>
                </div>
                  <div className='grid place-items-center justify-center p-4'> 
{/*  */}
{planes.map((gf,i)=>{
  const fe = JSON.parse(gf.api1)

  // console.log(gf.api1)
  return (
    <div className='text-3xl bg-[#161720] pb-12  p-2 rounded-xl text-center mt-5'>
    <div className='mt-5'>
    <span className='text-yellow-600'>{gf.name}</span>
    </div>
    <div className='text-2xl mt-2'>
      ${gf.price}/mo
    </div>
    <p className='text-xl pt-3 px-6 text-left'>
    {gf.description}             </p>
    <button className='btn rouned-xl btn-outline mt-4' onClick={()=>{
        navigate('/start/order/blog/' + gf.name, { replace: false })
        window.scrollBy(0,-90000000);}}>start now</button>
    <div className="divider px-4 mt-4"></div>

    <center className='w-auto text-xl'>
{fe.map((gf1,ii)=>{
  return(
    <div className='w-[14rem] mt-2 text-left'>
    <i className="fa-solid fa-circle-check text-blue-700 mr-1"></i>  {gf1.o}
    </div>
  )
})}


  </center>
  {/* <button className='btn rouned-xl btn-outline mt-4'>start now</button> */}
  </div>
  )
})}
                  </div>
              </div>
              
            </div>
            <div className='mt-12 text-2xl p-4 '>
            Do you need something in between or more?<a className='text-sky-600 cursor-pointer' href='https://discord.gg/KtZhay6wf6' target='_blank'> Contact us</a> 
            </div>
            <div className='mt-16'>
              
              <div className='text-4xl mb-4 text-center'>
              Dashborad
              </div>
              <img src='https://ghost.org/images/home/home-screenshot_hub16a8f8cd368011dde6bde1c63bdcb1f_730392_2400x0_resize_q100_h2_box_3.webp'></img>
            </div>
            <div className="trustpilot-widget" data-locale="en-US" data-template-id="5419b6a8b0d04a076446a9ad" data-businessunit-id="625953dc93b1919761576af9" data-style-height="24px" data-style-width="100%" data-theme="dark" data-min-review-count="10">
  <a href="https://www.trustpilot.com/review/skyex.me" target="_blank" rel="noopener">Trustpilot</a>
</div>
            <div className='mt-16'>
  <div className='grid bg-[#11131d] mb-16'>
<div id='f1' className="w-auto mt-8 text-white text-center text-4xl">
Frequently Asked Questions
</div>
<div className='text-white text-left md:px-32 p-5'>

  {/* 1 */}
<div tabindex="0" className="collapse mt-6 collapse-arrow border text-sm border-base-300 focus:bg-base-300 bg-base-200 rounded-box">
  <div className="collapse-title text-lg font-medium">
  Can I connect my existing domain?
  </div>
  <div className="collapse-content bg-base-300"> 
    <p>Yes, you will need to enter two records into your domain DNS in order to connect the site. Please reach out to us if you are having trouble connecting it.</p>
  </div>
</div>
{/*  */}
<div tabindex="0" className="collapse mt-6 collapse-arrow border text-sm border-base-300 focus:bg-base-300 bg-base-200 rounded-box">
  <div className="collapse-title text-lg font-medium">
  How many Visitors can the site handle?
  </div>
  <div className="collapse-content bg-base-300"> 
    <p>
    There's no simple answer, There are a lot of variables to consider like the language you are using,  your website content, server hardware contact support for more help.
    </p>  </div>
</div>
{/*  */}
<div tabindex="0" className="collapse mt-6 collapse-arrow border text-sm border-base-300 focus:bg-base-300 bg-base-200 rounded-box">
  <div className="collapse-title text-lg font-medium">
  Can You Help Me Move My Existing Sites Over?
  </div>
  <div className="collapse-content bg-base-300"> 
    <p>
We won’t just help; we’ll do all the work for you. Regardless of how many sites you currently have. Speak to our technical team once you’ve picked your desired plan and we’ll handle the rest, and at the pace you need us to.</p>
  </div>
</div>
{/* 2 */}
<div tabindex="0" className="collapse mt-6 collapse-arrow border text-sm border-base-300 focus:bg-base-300 bg-base-200 rounded-box">
  <div className="collapse-title text-lg font-medium">
  What Payment Gateways do you offer?
  </div>
  <div className="collapse-content bg-base-300"> 
    <p>For now PayPal which support debit and credit cards.</p>
  </div>
</div>
{/* 3 */}
<div tabindex="0" className="collapse mt-6 collapse-arrow border text-sm border-base-300 focus:bg-base-300 bg-base-200 rounded-box">
  <div className="collapse-title text-lg font-medium">
  What billing cycles do you offer?
  </div>
  <div className="collapse-content bg-base-300"> 
    <p>You can pay monthly or for 1, 2 or 3 years up front. If you decide to pre-pay, we give you some great discounts on our ongoing pricing,to pre-pay you would have to contact support.</p>
  </div>
</div>

<div tabindex="0" className="collapse mt-6 collapse-arrow border text-sm border-base-300 focus:bg-base-300 bg-base-200 rounded-box">
  <div className="collapse-title text-lg font-medium">
  Do you offer discounts for charities?
  </div>
  <div className="collapse-content bg-base-300"> 
    <p>Yes!, contact Support for more information.</p>
  </div>
</div>
<div tabindex="0" className="collapse mt-6 collapse-arrow border text-sm border-base-300 focus:bg-base-300 bg-base-200 rounded-box">
  <div className="collapse-title text-lg font-medium">
  What is CloudFlare protection?
  </div>
  <div className="collapse-content bg-base-300"> 
    <p>Cloudflare DDoS protection and Proxy secures websites, applications, and entire networks while ensuring the performance of legitimate traffic is not compromised .</p>
  </div>
</div>


</div>

</div>

  </div>
          </center>

          <div className='p-8  sm:hidden md:block'>
            <div className='flex justify-center'>
            <div  className=' -ml-12 max-w-xl p-5 '>
              <div className='text-left ml-3 leading-normal text-5xl'>
              Share your thoughts with anyone, anywhere.

              </div>
              <p className='text-gray-200 mt-2 ml-3'>
                Take Your business to a new level with our servers
              </p>
              <div className='grid ml-4 mt-2 leading-normal grid-cols-2'>
                <div>
                <i className="fa-solid fa-circle-check mr-1"></i>  Custom themes
                </div>
                <div>
                <i className="fa-solid fa-circle-check mr-1"></i>  Google Ads
                </div>
                <div className='mt-2'>
                <i className="fa-solid fa-circle-check mr-1"></i>   Multi-Language
                </div>
                <div className='mt-2'>
                <i className="fa-solid fa-circle-check mr-1"></i>   Tech Support
                </div>
                
              </div>
              <div className='ml-4 mt-8'>
                <button className='btn btn-primary btn-active'><a href='https://demob.skyex.me/' target='_blank'>TRY OUR DEMO</a></button>
              </div>
              </div>
              <div className='ml-[8rem] -mt-8 float-right min-w-[8rem] flex-initial p-8'>
                <img alt='server image' src='/cloud-web-hosting.svg' className=""/>
              </div>
            </div>

<div className='grid place-items-center'>
  <div className='text-4xl mt-28'>
  <AnimationOnScroll animateOnce='true' offset='8' animateIn="animate__bounceIn">
  plans
                  </AnimationOnScroll>

  </div>
  <div className='grid md:grid-cols-2 lg:grid-cols-3 place-items-center justify-center  mt-3'>
  {planes.map((gf,i)=>{
  const fe = JSON.parse(gf.api1)

  // console.log(gf.api1)
  // online
  if(gf.is_sale == 0){
    return (

      <div className='text-3xl mr-6 bg-[#161720] pb-12  p-2 w-[26rem] rounded-xl text-center mt-5'>
      <div className='mt-5'>
      <span className='text-yellow-600'>{gf.name}</span>
      </div>
      <div className='text-2xl mt-2'>
        ${gf.price}/mo
      </div>
      <p className='text-xl pt-3 px-6 text-left'>
      {gf.description}             </p>
      <button className='btn rouned-xl btn-outline mt-4' onClick={()=>{
        navigate('/start/order/blog/' + gf.name, { replace: false })
        window.scrollBy(0,-90000000);}}>start now</button>
      <div className="divider px-4 mt-4"></div>
  
      <center className='w-auto text-xl'>
  {fe.map((gf1,ii)=>{
    return(
      <div className='w-[14rem] mt-2 text-left'>
      <i className="fa-solid fa-circle-check text-blue-700 mr-1"></i>  {gf1.o}
      </div>
    )
    
  })}
  
    </center>
    {/* <button className='btn rouned-xl btn-outline mt-4'>start now</button> */}
    
    </div>
    )
    // sold out
  }else if(gf.is_sale == 2){
    return (

      <div className='text-3xl mr-6 bg-[#161720] pb-12  p-2 w-[26rem] rounded-xl text-center mt-5'>
      <div className='mt-5'>
      <span className='text-yellow-600'>{gf.name}</span>
      </div>
      <div className='text-2xl mt-2'>
        ${gf.price}/mo
      </div>
      <p className='text-xl pt-3 px-6 text-left'>
      {gf.description}             </p>
      <button className='btn rouned-xl border-red-700 text-red-600 btn-outline mt-4'>SOLD OUT</button>
      <div className="divider px-4 mt-4"></div>
  
      <center className='w-auto text-xl'>
  {fe.map((gf1,ii)=>{
    return(
      <div className='w-[14rem] mt-2 text-left'>
      <i className="fa-solid fa-circle-check text-blue-700 mr-1"></i>  {gf1.o}
      </div>
    )
    
  })}
  
    </center>
    {/* <button className='btn rouned-xl btn-outline mt-4'>start now</button> */}
    </div>
    )
    // on sale
  }else if(gf.is_sale == 1){
    return (

      <div className='text-3xl mr-6 bg-[#161720] pb-12  p-2 w-[26rem] rounded-xl text-center mt-5'>
      <div className='mt-5'>
      <span className='text-yellow-600'>{gf.name}</span>
      </div>
      <div className='text-2xl mt-2'>
        ${gf.price}/mo
      </div>
      <p className='text-xl pt-3 px-6 text-left'>
      {gf.description}             </p>
      <button className='btn rouned-xl btn-outline mt-4' onClick={()=>{
        navigate('/start/order/blog/' + gf.name, { replace: false })
        window.scrollBy(0,-90000000);}}>start now</button>
      <div className="divider px-4 mt-4"></div>
  
      <center className='w-auto text-xl'>
  {fe.map((gf1,ii)=>{
    return(
      <div className='w-[14rem] mt-2 text-left'>
      <i className="fa-solid fa-circle-check text-blue-700 mr-1"></i>  {gf1.o}
      </div>
    )
    
  })}
  
    </center>
    {/* <button className='btn rouned-xl btn-outline mt-4'>start now</button> */}
    </div>
    )
  }

})}
  </div>


  <div className='mt-16 text-2xl'>
  Do you need something in between or more?<a className='text-sky-600 cursor-pointer' href='https://discord.gg/KtZhay6wf6' target='_blank'> Contact us</a> 
            </div>

            {/* <div className='mt-16'>
              
              <div className='text-4xl mb-4 text-center'>
              Dashborad
              </div>
              <img src='https://ghost.org/images/home/home-screenshot_hub16a8f8cd368011dde6bde1c63bdcb1f_730392_2400x0_resize_q100_h2_box_3.webp'></img>
            </div> */}
<div className="trustpilot-widget" data-locale="en-US" data-template-id="5419b6a8b0d04a076446a9ad" data-businessunit-id="625953dc93b1919761576af9" data-style-height="24px" data-style-width="100%" data-theme="dark" data-min-review-count="10">
  <a href="https://www.trustpilot.com/review/skyex.me" target="_blank" rel="noopener">Trustpilot</a>
</div>
  <div className='mt-16'>
  <div className='grid bg-[#11131d] mb-16'>
<div id='f1' className="w-auto mt-8 text-white text-center text-4xl">
Frequently Asked Questions
</div>
<div className='text-white md:px-32 p-5'>

  {/* 1 */}
<div tabindex="0" className="collapse mt-6 collapse-arrow border text-sm border-base-300 focus:bg-base-300 bg-base-200 rounded-box">
  <div className="collapse-title text-lg font-medium">
  Can I connect my existing domain?
  </div>
  <div className="collapse-content bg-base-300"> 
    <p>Yes, you will need to enter two records into your domain DNS in order to connect the site. Please reach out to us if you are having trouble connecting it.</p>
  </div>
</div>
{/*  */}
<div tabindex="0" className="collapse mt-6 collapse-arrow border text-sm border-base-300 focus:bg-base-300 bg-base-200 rounded-box">
  <div className="collapse-title text-lg font-medium">
  How many Visitors can the site handle?
  </div>
  <div className="collapse-content bg-base-300"> 
    <p>
    There's no simple answer, There are a lot of variables to consider like the language you are using,  your website content, server hardware contact support for more help.
    </p>  </div>
</div>
{/*  */}
<div tabindex="0" className="collapse mt-6 collapse-arrow border text-sm border-base-300 focus:bg-base-300 bg-base-200 rounded-box">
  <div className="collapse-title text-lg font-medium">
  Can You Help Me Move My Existing Sites Over?
  </div>
  <div className="collapse-content bg-base-300"> 
    <p>
We won’t just help; we’ll do all the work for you. Regardless of how many sites you currently have. Speak to our technical team once you’ve picked your desired plan and we’ll handle the rest.</p>
  </div>
</div>
{/* 2 */}
<div tabindex="0" className="collapse mt-6 collapse-arrow border text-sm border-base-300 focus:bg-base-300 bg-base-200 rounded-box">
  <div className="collapse-title text-lg font-medium">
  What Payment Gateways do you offer?
  </div>
  <div className="collapse-content bg-base-300"> 
    <p>For now PayPal which support debit and credit cards.</p>
  </div>
</div>
{/* 3 */}
<div tabindex="0" className="collapse mt-6 collapse-arrow border text-sm border-base-300 focus:bg-base-300 bg-base-200 rounded-box">
  <div className="collapse-title text-lg font-medium">
  What billing cycles do you offer?
  </div>
  <div className="collapse-content bg-base-300"> 
    <p>You can pay monthly or for 1, 2 or 3 years up front. If you decide to pre-pay, we give you some great discounts on our ongoing pricing,to pre-pay you would have to contact support.</p>
  </div>
</div>

<div tabindex="0" className="collapse mt-6 collapse-arrow border text-sm border-base-300 focus:bg-base-300 bg-base-200 rounded-box">
  <div className="collapse-title text-lg font-medium">
  Do you offer discounts for charities?
  </div>
  <div className="collapse-content bg-base-300"> 
    <p>Yes!, contact Support for more information.</p>
  </div>
</div>
<div tabindex="0" className="collapse mt-6 collapse-arrow border text-sm border-base-300 focus:bg-base-300 bg-base-200 rounded-box">
  <div className="collapse-title text-lg font-medium">
  What is CloudFlare protection?
  </div>
  <div className="collapse-content bg-base-300"> 
    <p>Cloudflare DDoS protection and Proxy secures websites, applications, and entire networks while ensuring the performance of legitimate traffic is not compromised .</p>
  </div>
</div>


</div>

</div>

  </div>
</div>
            </div>

<div className="flex flex-col w-full mt-16">

{error.length > 0 && (
  <>
  <div className="hero w-auto  flex mt-8 mx-4 max-w-xl justify-center">
<img alt='404' className='hero' src={'https://www.jea.com/cdn/images/backgrounds/404/404-bg-img.svg'} />
</div>
<div id='f2' className='hero w-screen p-2 text-center text-black'>{error}
                        </div>
  </>
        
)}

          <div className="grid place-items-center sm:grid-cols-1 md:grid-cols-3">
          </div>
</div>

        


        </div>
<Darkfoot />


        </>
    )}else if(tab == 'loading'){
      return(
        <>


<div className=" bg-[#11131d] h-[110vh]">
<div className="w-full h-[6rem] -mt-[6.53rem]  scrollbar-hide bg-[#11131d] text-white">

</div>
             <div className="hero mt-[30vh]">
             <button className="btn btn-square bg-[#11131d] btn-lg border-[#11131d] text-2xl loading"></button>
      
</div>
</div>
  </>
      )


    }
}
// https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTCfpasLagF5aIXVv3HCwnWmqLhYFP5BTi8cw&usqp=CAU
export default Blog

